// @ts-nocheck
import React from 'react'
import * as Sentry from '@sentry/react'

import { ErrorBoundaryProps } from './ErrorBoundary.types'

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
    return (
        <Sentry.ErrorBoundary fallback={<div>Application error. Please refresh your page</div>}>
            {children}
        </Sentry.ErrorBoundary>
    )
}

export default ErrorBoundary
